export enum FieldName {
  email = "email",
  phoneNumber = "phoneNumber",
  m1 = "m1",
  m2 = "m2",
  m3 = "m3",
  m4 = "m4",
  m5 = "m5",
  m6 = "m6",
  m8 = "m8",
  m9 = "m9",
  m11 = "m11",
  m12 = "m12",
  m13 = "m13",
  m14 = "m14",
  m15 = "m15",
  m16 = "m16",
  m17 = "m17",
  m18 = "m18",
  m19 = "m19",
  m20 = "m20",
  m21 = "m21",
  m22 = "m22",
  m23 = "m23",
  m24 = "m24",
  m25 = "m25",
  m26 = "m26",
  submitter = "submitter",
  submitted = "submitted",
}

export interface Input {
  [FieldName.email]: string;
  [FieldName.phoneNumber]: number;
  [FieldName.m1]: boolean;
  [FieldName.m2]: boolean;
  [FieldName.m3]: boolean;
  [FieldName.m4]: boolean;
  [FieldName.m5]: boolean;
  [FieldName.m6]: boolean;
  [FieldName.m8]: boolean;
  [FieldName.m9]: boolean;
  [FieldName.m11]: boolean;
  [FieldName.m12]: boolean;
  [FieldName.m13]: boolean;
  [FieldName.m14]: boolean;
  [FieldName.m15]: boolean;
  [FieldName.m16]: boolean;
  [FieldName.m17]: boolean;
  [FieldName.m18]: boolean;
  [FieldName.m19]: boolean;
  [FieldName.m20]: boolean;
  [FieldName.m21]: boolean;
  [FieldName.m22]: boolean;
  [FieldName.m23]: boolean;
  [FieldName.m24]: boolean;
  [FieldName.m25]: boolean;
  [FieldName.m26]: boolean;
}
